// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle__dot-neworhot{top:-.25rem;left:-.25rem;transition:all .3s ease-in-out}input:checked~.toggle__dot-neworhot{transform:translateX(100%)}.hot-or-new-small{font-size:.6rem;padding-top:.25rem;padding-left:.25rem}.hot-or-new-large{font-size:.875rem;font-weight:700;margin-top:.25rem}", ""]);
// Exports
module.exports = exports;
